import PropTypes from 'prop-types';
import { searchResultsProductsPropTypes } from './components/SearchResultsProducts/SearchResultsProductsPropTypes';
import { searchResultsContentPropTypes } from './components/SearchResultsContent/SearchResultsContentPropTypes';
export const searchResultsPropTypes = {
  searchResults: PropTypes.shape({
    status: PropTypes.shape({
      isFetching: PropTypes.bool,
      isLoaded: PropTypes.bool
    }),
    notFoundDescription: PropTypes.string,
    products: PropTypes.shape(searchResultsProductsPropTypes),
    content: searchResultsContentPropTypes.items,
    popularSearches: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      href: PropTypes.string
    }))
  }),
  setIsSearching: PropTypes.func,
  isSearching: PropTypes.bool,
  searchTerm: PropTypes.string,
  sendSearchData: PropTypes.func,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  popularSearches: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    href: PropTypes.string
  }))
};